import {html} from "./utils/environment";

console.log("Started JS App");

html.classList.add("is-loaded");
html.classList.add("is-ready");
html.classList.remove("is-loading");

/**
 * Aggiunge un'immagine di fallback per le immagini non trovate
 */
const images = document.querySelectorAll("img");

images.forEach((image) => {
    image.addEventListener("error", (event) => {
        image.src = m6e.templateUrl + '/assets/images/placeholder.png';
        image.alt = "Image not found"
    });
});

/**
 * Aggiunge un'icona di dropdown agli elementi del menu
 */
document.querySelectorAll("#menu-item-116367 li.menu-item-has-children > a").forEach(a => {
    a.insertAdjacentHTML("beforeend", '<span class="ct-toggle-dropdown-desktop"><svg class="ct-icon" width="8" height="8" viewBox="0 0 15 15"><path d="M2.1,3.2l5.4,5.4l5.4-5.4L15,4.3l-7.5,7.5L0,4.3L2.1,3.2z"></path></svg></span>');
});
